var _defs;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
var SvgSpheresLogo = function SvgSpheresLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#2A2924",
    filter: "url(#spheres-logo_filter0_d_2234_13780)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.014,
    cy: 9.956,
    rx: 1.952,
    ry: 1.956,
    style: _defineProperty(_defineProperty({
      fill: "#2a2924"
    }, "fill", "color(display-p3 .1647 .1608 .1412)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.014,
    cy: 30.044,
    rx: 1.952,
    ry: 1.956,
    style: _defineProperty(_defineProperty({
      fill: "#2a2924"
    }, "fill", "color(display-p3 .1647 .1608 .1412)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.048,
    cy: 20.017,
    rx: 1.952,
    ry: 1.956,
    style: _defineProperty(_defineProperty({
      fill: "#2a2924"
    }, "fill", "color(display-p3 .1647 .1608 .1412)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.952,
    cy: 20.017,
    rx: 1.952,
    ry: 1.956,
    style: _defineProperty(_defineProperty({
      fill: "#2a2924"
    }, "fill", "color(display-p3 .1647 .1608 .1412)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.014,
    cy: 20.017,
    rx: 3.881,
    ry: 3.889,
    style: _defineProperty(_defineProperty({
      fill: "#2a2924"
    }, "fill", "color(display-p3 .1647 .1608 .1412)"), "fillOpacity", 1)
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "spheres-logo_filter0_d_2234_13780",
    width: 39.245,
    height: 39.245,
    x: 0.377,
    y: 0.377,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.811
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2234_13780"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2234_13780",
    result: "shape"
  })))));
};
export default SvgSpheresLogo;